// Translator notes: Idioms and kennings (engine/src/idioms.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  idiom: {
    args: ['hv', 'meaning', 'literal'],
    fi: (a: string[]) => `Kuvaannollinen ilmaus: ”${a[0]}” tarkoittaa ’${a[1]}’${a[2] ? `, kirjaimellisesti ’${a[2]}’` : ''}.`,
    en: (a: string[]) => `Figurative expression: “${a[0]}” means ‘${a[1]}’${a[2] ? `, literally ‘${a[2]}’` : ''}.`,
  },
  idiomHint: {
    args: ['hv', 'meaning', 'literal'],
    fi: (a: string[]) => `Valyriassa tähän on myös idiomi ”${a[0]}” (’${a[1]}’${a[2] ? `, kirjaimellisesti ’${a[2]}’` : ''}).`,
    en: (a: string[]) => `High Valyrian also has an idiom for this: “${a[0]}” (‘${a[1]}’${a[2] ? `, literally ‘${a[2]}’` : ''}).`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
